import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Map",
            key: "map",
            route: "/map/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;